import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

/**
 * Use this component to set standardized padding and max width on pages.
 */
@Component({
  imports: [CommonModule],
  selector: 'details-card',
  standalone: true,
  styleUrls: ['./details-card.component.scss'],
  templateUrl: './details-card.component.html',
})
export class DetailsCardComponent {
  @Input() title: string = '';
  @Input() description?: string | undefined = undefined;
}
